export default {
  zoneFeatures: {
    SHOW_JOBCARD_TEASER_IN_SPLITVIEW: true,
    SHOULD_OPEN_APPLY_IN_NEW_TAB: false,
    STICK_APPLY_BUTTON_ON_DESKTOP: true,
    REMOTE_SEARCH_FILTER: false,
    REDUCED_DUPLICATED_APPLY: true,
    SHOW_JOB_DISPLAY_TAGS: true,
  },
  // Treatment from https://github.com/SEEK-Jobs/wpt-static-pages/blob/395296a5bee64cb228f54d5355ea2afde93d801a/src/pages/error/not-found/App.tsx#L60C28-L60C28
  contactUsUrl: 'tel: 0508 733 569',
};
